function GetSelectedRadiusAroundAddress() {
    $('#divRadiusAddressResults input[type = radio]').click(function () {
        var $hiddenValue = $('.RadiusAroundAddressResultsContainer input[type = hidden]');
        $hiddenValue.val($(this).val() + '~' + $(this).next('span').html());
    });
    $('#divRadiusAddressResults input[type = radio]:first').click();
}
